import { useEffect, useState } from 'react';

import { IMAGES } from '@/assets/images';
import { getPreloadedAssetUrl } from '@/utils/assetManifest';
import { SequenceRecallGameShell } from '@features/sequence-recall/components/SequenceRecallGameShell';
import '@styles/sequence-recall.css';

/**
 * Home page.
 *
 * @returns {JSX.Element} The rendered element.
 */
export default function HomePage() {
  const [isCompactLandscape, setIsCompactLandscape] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(orientation: landscape) and (max-height: 610px)');
    /**
     * Handles change.
     *
     * @param {MediaQueryListEvent} event - The event.
     *
     * @returns {void} No return value.
     */
    const handleChange = (event: MediaQueryListEvent) => {
      setIsCompactLandscape(event.matches);
    };

    setIsCompactLandscape(mediaQuery.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return (
    <main className="flex h-[100dvh] overflow-hidden w-full items-center justify-center bg-mainbackground">
      <div className="absolute inset-0 gradient-layer-top" />
      <SequenceRecallGameShell />
      {isCompactLandscape && (
        <div className="absolute inset-0 z-50 w-full flex flex-col items-center justify-center px-4 text-center bg-mainbackground">
          <div
            className="pointer-events-none absolute inset-0 scale-150 bg-contain bg-center bg-no-repeat opacity-20 h-full md:h-[80vh] top-1/2 -translate-y-1/2"
            style={{ backgroundImage: `url('${getPreloadedAssetUrl(IMAGES.brownBg)}')` }}
          />
          <div className="phone" />
          <div className="message">
            <p className="text-lg tracking-[0.14em] text-white uppercase font-bold">
              Tilt detected!
            </p>
            <p className="max-w-[340px] mx-auto text-center text-[14px] tracking-[0.13em] text-white/80">
              Switch to portrait mode to keep playing
            </p>
          </div>
        </div>
      )}
    </main>
  );
}
